import { useMemo } from 'react';
import { getLocaleStringFormatted } from '../../../translations';
import FeatureConfig, {
  Feature,
  isFeatureEnabled,
} from '../../../config/FeaturesConfig';

const useSummaryTargetLanguage = () => {
  return useMemo(() => {
    const isSummaryTranslationEnabled = isFeatureEnabled(
      Feature.CSA_SUMMARIES_TRANSLATIONS
    );

    if (!isSummaryTranslationEnabled) return undefined;

    return getLocaleStringFormatted() || 'en-US';
  }, []);
};
export default useSummaryTargetLanguage;
